export default __webpack_public_path__ + "static/media/support.0109f78e.svg";